var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('recipe-filter-chips'),_c('v-spacer'),_c('base-sort',{attrs:{"columns":_vm.columns},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}})],1),_vm._l((_vm.computedRecipes),function(recipe){return _c('recipe-list-item',{key:recipe.id,attrs:{"recipe":recipe}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }